exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".increasing{\n  background-color: limegreen;\n}\n\n.decreasing{\n  background-color: red;\n}\n\n.decimal{\n  text-align: right;\n}\n\nth{\n  text-align: center;\n}\n\n.stock-row{\n  cursor: pointer;\n}\n\n.stock-row.active{\n  background-color: darkgrey;\n}\n\n.chart-panel{\n  margin-top: 20px;\n}\n\n.chart-div{\n  margin-top: 20px;\n}\n\n.row{\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/travis/build/nishant95/stocks-app/src/app/modules/stock-list/stock-list/stock-list.component.css
// module id = ../../../../../src/app/modules/stock-list/stock-list/stock-list.component.css
// module chunks = main